import { useNavigate, useLocation } from 'react-router-dom'

const HomeIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
const EventsIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 010-5H6"/><path d="M18 9h1.5a2.5 2.5 0 000-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0012 0V2z"/></svg>
const PlayFlagIcon = () => <svg viewBox="0 0 24 24" fill="none"><ellipse cx="12" cy="20" rx="8" ry="2.4" fill="currentColor" opacity="0.35"/><path d="M9 20V5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M9 5l7 2.3L9 9.6z" fill="currentColor"/></svg>
const StatsIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>
const CoursesIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>

const sideItems = [
  { path: '/',        icon: <HomeIcon />,    label: 'Home',    pos: 0 },
  { path: '/events',  icon: <EventsIcon />,  label: 'Events',  pos: 1 },
  { path: '/courses', icon: <CoursesIcon />, label: 'Courses', pos: 3 },
  { path: '/history', icon: <StatsIcon />,   label: 'Stats',   pos: 4 },
]

export default function BottomNav() {
  const navigate = useNavigate()
  const location = useLocation()
  const path = location.pathname

  return (
    <nav className="bottom-nav">
      {sideItems.filter(i => i.pos < 2).map(item => (
        <button key={item.path}
          className={`nav-item${path === item.path ? ' active' : ''}`}
          onClick={() => navigate(item.path)}>
          {item.icon}<span>{item.label}</span>
        </button>
      ))}

      {/* Center Play button — podium / FAB style */}
      <button
        className={`nav-item nav-play${path === '/play' ? ' active' : ''}`}
        onClick={() => navigate('/play')}
      >
        <div className="nav-play-ball">
          <img src="/golfball.png" alt="" className="nav-play-ball-img" />
          <div className="nav-play-inner">
            <PlayFlagIcon />
            <span>Play</span>
          </div>
        </div>
      </button>

      {sideItems.filter(i => i.pos > 2).map(item => (
        <button key={item.path}
          className={`nav-item${path === item.path ? ' active' : ''}`}
          onClick={() => navigate(item.path)}>
          {item.icon}<span>{item.label}</span>
        </button>
      ))}
    </nav>
  )
}
